var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "plan-feature" } }, [
    _c("div", { staticClass: "feature" }, [
      _c("div", { staticClass: "feature-title" }, [
        _vm._v(_vm._s(_vm.$t("message.webphoneFeatures"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "feature-delete",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_c("span", { staticClass: "material-icons" }, [_vm._v("close")])]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "feature-form" }, [
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [
          _vm._v(_vm._s(_vm.$t("message.channelCount"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.webphoneChannelCount,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "webphoneChannelCount", $$v)
                },
                expression: "featureForm.webphoneChannelCount",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c(
          "div",
          { staticClass: "feature-checkbox" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.integratedWebPhone,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "integratedWebPhone", $$v)
                  },
                  expression: "featureForm.integratedWebPhone",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.integratedWebPhone")))]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c(
          "div",
          { staticClass: "feature-checkbox" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.clickToCall,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "clickToCall", $$v)
                  },
                  expression: "featureForm.clickToCall",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.clickToCallFeature")))]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c(
          "div",
          { staticClass: "feature-checkbox" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.callHistory,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "callHistory", $$v)
                  },
                  expression: "featureForm.callHistory",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.webPhoneCallHistory")))]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c(
          "div",
          { staticClass: "feature-checkbox" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.generalCallRecords,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "generalCallRecords", $$v)
                  },
                  expression: "featureForm.generalCallRecords",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.generalCallRecords")))]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c(
          "div",
          { staticClass: "feature-checkbox" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.userExtensionMapping,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "userExtensionMapping", $$v)
                  },
                  expression: "featureForm.userExtensionMapping",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.userExtensionMapping")))]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c(
          "div",
          { staticClass: "feature-checkbox" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.webphoneAutomations,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "webphoneAutomations", $$v)
                  },
                  expression: "featureForm.webphoneAutomations",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.webphoneAutomations")))]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c(
          "div",
          { staticClass: "feature-checkbox" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.extensionListing,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "extensionListing", $$v)
                  },
                  expression: "featureForm.extensionListing",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.extensionListing")))]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c(
          "div",
          { staticClass: "feature-checkbox" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.internalCalling,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "internalCalling", $$v)
                  },
                  expression: "featureForm.internalCalling",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.internalCalling")))]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c(
          "div",
          { staticClass: "feature-checkbox" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.callRouting,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "callRouting", $$v)
                  },
                  expression: "featureForm.callRouting",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.callRouting")))]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c(
          "div",
          { staticClass: "feature-checkbox" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.coldCallStart,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "coldCallStart", $$v)
                  },
                  expression: "featureForm.coldCallStart",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.coldCallStart")))]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c(
          "div",
          { staticClass: "feature-checkbox" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.automationColdCall,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "automationColdCall", $$v)
                  },
                  expression: "featureForm.automationColdCall",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.automationColdCall")))]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c(
          "div",
          { staticClass: "feature-checkbox" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.ivr,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "ivr", $$v)
                  },
                  expression: "featureForm.ivr",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.ivrRedStation")))]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c(
          "div",
          { staticClass: "feature-checkbox" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.voiceAnnouncement,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "voiceAnnouncement", $$v)
                  },
                  expression: "featureForm.voiceAnnouncement",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.voiceAnnouncement")))]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c(
          "div",
          { staticClass: "feature-checkbox" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.satisfactionSurveyCall,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "satisfactionSurveyCall", $$v)
                  },
                  expression: "featureForm.satisfactionSurveyCall",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.satisfactionSurveyCall")))]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c(
          "div",
          { staticClass: "feature-checkbox" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.customizableCloudPbx,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "customizableCloudPbx", $$v)
                  },
                  expression: "featureForm.customizableCloudPbx",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.customizableCloudPbx")))]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c(
          "div",
          { staticClass: "feature-checkbox" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.liveQueueMonitoring,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "liveQueueMonitoring", $$v)
                  },
                  expression: "featureForm.liveQueueMonitoring",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.liveQueueMonitoring")))]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c(
          "div",
          { staticClass: "feature-checkbox" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.aiVoiceAgentIntegration,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "aiVoiceAgentIntegration", $$v)
                  },
                  expression: "featureForm.aiVoiceAgentIntegration",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.aiVoiceAgentIntegration")))]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c(
          "div",
          { staticClass: "feature-checkbox" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.contactCallHistory,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "contactCallHistory", $$v)
                  },
                  expression: "featureForm.contactCallHistory",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.contactCallHistory")))]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c(
          "div",
          { staticClass: "feature-checkbox" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.callProfileDisplay,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "callProfileDisplay", $$v)
                  },
                  expression: "featureForm.callProfileDisplay",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.callProfileDisplay")))]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c(
          "div",
          { staticClass: "feature-checkbox" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.multipleWebPhone,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "multipleWebPhone", $$v)
                  },
                  expression: "featureForm.multipleWebPhone",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.multipleWebPhone")))]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c(
          "div",
          { staticClass: "feature-checkbox" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.voiceRecordingStorage,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "voiceRecordingStorage", $$v)
                  },
                  expression: "featureForm.voiceRecordingStorage",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.voiceRecordingStorage")))]
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }